import React, { useContext } from "react";
import DragItem from "./DragItem";
import { Grid, GridItem } from "./Grid";
import GridContext from "./GridContext";
import "../../../../styles/dnd.css"

function App1() {
  const { items, moveItem, updateOptions, noOfRight } = useContext(GridContext);

  let itemsList = []
  const ShowList = () => {
    for(let x = 0; x < items.length; x++){
      itemsList.push(<DragItem key={items[x].index} id={items[x].index} onMoveItem={moveItem}>
        <GridItem>
          <p style={{ display:"flex", fontSize: "2.4vh", color:"#ffffff", margin:"auto"}} >
            {x+1}.
          </p>
          <li
          className={x<noOfRight?"selected":""}
            style={typoStyles}>
              {items[x].option}
          </li>
        </GridItem>
      </DragItem>)
    }
    return itemsList
  }
  ShowList()
  return (
    <div>
      <Grid style={{display: "flex", justifyContent: "center"}}>
        {updateOptions(items)}
        {itemsList}
      </Grid>
    </div>
  );
}

const typoStyles = {
  color: "#000",
  fontSize: "1.8vh",
  background: "#dbdbdb",
  padding: "1.5vh",
  margin: "1vh auto",
  borderRadius: "15px",
  lineHeight: "1.2vw",
  userSelect: "none",
  MSUserSelect: "none",
  MozUserSelect: "none",
  WebkitUserSelect: "none",
  cursor: "grabbing",
  cursor: "-webkit-grabbing",
  display: "inline-block",
  width: "65%",
  justifyContent: "center",
  textAlign: "center",
}

export default App1;
